/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import T from 'i18n-react';
import type { NextPage } from 'next';

import { AccountPage as NewAccountPage } from 'Components/Account/AccountPage';
import useAccountRouter from 'Components/Account/useAccountRouter';
import MetaTags from 'Components/MetaTags/MetaTags';
import PageComposer from 'Components/PageComposer/PageComposer';
import PageLoadingIndicator from 'Components/PageLoadingIndicator/PageLoadingIndicator';
import AccountPage from 'Components/pages/AccountPage/AccountPage';
import texts from 'Components/texts.json';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import { AccountFiltersStoreProvider } from 'Stores/AccountFiltersStore/AccountFiltersContext';
import { PAGE_SLUGS } from 'Utilities/consts';
import { accountRouteHandler } from 'Utilities/getInitialPropsMiddlewares/accountRouteHandler/accountRouteHandler';
import { auth } from 'Utilities/getInitialPropsMiddlewares/auth/auth';
import type { GetInitialPropsMiddlewareContext } from 'Utilities/getInitialPropsMiddlewares/getInitialPropsMiddlewares.types';
import { createMiddlewarePipeline } from 'Utilities/helpers/middlewarePipeline/middlewarePipeline';

T.setTexts(texts);

const Account: NextPage<{}> = () => {
	const { category } = useAccountRouter();

	const {
		minWidth: { breakpointTablet: isDesktopView },
	} = useBreakpoint();

	let AccountSection;

	switch (isDesktopView) {
		case true:
			AccountSection = NewAccountPage;
			break;
		case false:
			AccountSection = AccountPage;
			break;
		default:
			AccountSection = PageLoadingIndicator;
	}

	return (
		<>
			<MetaTags
				// @ts-expect-error MetaTags needs to be rewritten to TS
				description={T.translate(`account.meta.${category}.description`)}
				title={T.translate(`account.meta.${category}.title`)}
			/>
			<PageComposer pageSlug={PAGE_SLUGS.ACCOUNT}>
				<AccountFiltersStoreProvider>
					<AccountSection category={category} />
				</AccountFiltersStoreProvider>
			</PageComposer>
		</>
	);
};

Account.getInitialProps = async (context) => {
	const middlewarePipeline = createMiddlewarePipeline<GetInitialPropsMiddlewareContext>(auth, accountRouteHandler);
	const getInitialPropsMiddlewareContext: GetInitialPropsMiddlewareContext = {
		nextContext: context,
		returnValue: {},
	};

	await middlewarePipeline.run(getInitialPropsMiddlewareContext);

	return getInitialPropsMiddlewareContext.returnValue;
};

export default Account;
